import { FORMULA_TYPES } from 'constants/all';

import request from 'utils/request';

export default {
  compilePricingFormula: async ({ formula, supplierId, profitItemDefId }) =>
    await request.post('/formula/compile/v2', {
      formula,
      type: FORMULA_TYPES.PROFIT_ITEM,
      supplierId,
      profitItemDefId,
    }),
  create: async (groupId, data) =>
    await request.post(`/suppliers/${groupId}/profit_item_definitions`, data),
  delete: async (profitItemId) =>
    await request.delete(`/suppliers/profit_item_definitions/${profitItemId}`),
  get: async (profitItemId) =>
    await request.get(`/suppliers/profit_item_definitions/${profitItemId}`),
  list: async (groupId, params = {}) =>
    await request.get(`/suppliers/${groupId}/profit_item_definitions`, params),
  update: async (profitItemId, data) =>
    await request.patch(
      `/suppliers/profit_item_definitions/${profitItemId}`,
      data,
    ),
  updatePricingFormula: async (profitItemId, formula, revertedFrom) =>
    await request.patch(
      `/suppliers/profit_item_definitions/${profitItemId}/formula`,
      {
        formula,
        revertedFrom,
      },
    ),
  updateVariable: async (variableId, data) =>
    await request.patch(`/formulas/variables/${variableId}`, data),
};
